import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Conta plantões em andamento do paciente e permite sincronizar
 * as atividades de um item do plano de cuidado com esses plantões.
 */
export function useActiveShiftSync(patientId?: string) {
  const [activeShiftCount, setActiveShiftCount] = useState(0);

  useEffect(() => {
    if (!patientId) return;
    let cancelled = false;

    (async () => {
      const { data } = await supabase
        .from('shifts')
        .select('id')
        .eq('patient_id', patientId)
        .in('status', ['active', 'in_progress']);

      if (!cancelled) setActiveShiftCount((data || []).length);
    })();

    return () => { cancelled = true; };
  }, [patientId]);

  const syncTask = useCallback(async (taskId: string) => {
    if (!patientId || !taskId) return null;
    const { data, error } = await supabase.rpc('sync_care_plan_task_to_active_shifts' as any, {
      p_task_id: taskId,
      p_patient_id: patientId,
    });
    if (error) throw error;
    const row = Array.isArray(data) ? (data[0] as any) : (data as any);
    return {
      added: row?.added ?? 0,
      removed: row?.removed ?? 0,
      updated: row?.updated ?? 0,
    };
  }, [patientId]);

  return { activeShiftCount, hasActiveShift: activeShiftCount > 0, syncTask };
}
